export class InspectionResult {
	constructor() {
		this.questionId = null;
		this.value = null;
		this.comments = null;
		this.photos = [];
	}

	static hydrate(jsonData, opts = {}) {
        if(jsonData == null) { return null; }
        let ir = Object.assign(new InspectionResult(), jsonData);
		return ir;
	}

	get isEmpty() {
		return !(!!this.value || !!this.comments || this.photos.length > 0);
	}

	get isComplete() {
		return !!this.value;
	}
}